import {apiClient} from 'common/util/api-client';

import {queryApiUrl} from '../utils';

export async function classifyEvents(projectId: string): Promise<void> {
  const url = queryApiUrl(`data_definitions/classify`);
  const params = {
    project_id: projectId,
  };
  await apiClient.get(url, params);
}
